export const undoEventName = 'editor_undo';
export const focusEventName = 'editor_focus';
